import React, { useState } from "react";
import styled from "styled-components";
import { motion, AnimatePresence } from "framer-motion";
import { Link, navigate } from "gatsby";
import Stack from "@components/Stack";
import { useLockBodyScroll } from "@hooks";

import { media } from "@styles";
import { Turn as Hamburger } from "hamburger-react";

const container = {
  hidden: {
    // y: "-3px"
    // transition: {
    //   staggerChildren: 0.05,
    //   when: "afterChildren"
    // }
  },
  show: {
    // x: "0%",
    transition: {
      staggerChildren: 0.05
      // when: "beforeChildren"
    }
  }
};

const item = {
  hidden: { opacity: 0, x: "20%" },
  show: {
    opacity: 1,
    x: "0%"
  }
};

function Navigation({ toggleContact }: any) {
  const path = typeof window !== "undefined" ? window.location.pathname : "";

  const [shouldShow, setShouldShow] = useState(false);
  const [navigateDestination, setNavigateDestination] = useState("");

  useLockBodyScroll(shouldShow);
  return <></>
  return (
    <Nav>
      <BrandLogoContainer to="/" onClick={() => setShouldShow(false)}>
        <BrandLogo />
      </BrandLogoContainer>

      <BurgerIconContainer
        type="row"
        gap={4}
        path={path}
        shouldShow={shouldShow}
      >
        <AnimatePresence
          exitBeforeEnter
          onExitComplete={() => {
            if (navigateDestination !== "") {
              navigate(navigateDestination);
            }

            setNavigateDestination("");
          }}
        >
          {shouldShow && (
            <DesktopMenuContainer
              key="bg-desktop"
              type="row"
              gap={5}
              center
              variants={container}
              initial="hidden"
              animate="show"
              exit="hidden"
              // transition={{ duration: 0.3 }}
            >
              <DesktopLinkText
                variants={item}
                onClick={() => {
                  setNavigateDestination("/work");
                  setShouldShow(false);
                }}
              >
                work
              </DesktopLinkText>
              <DesktopLinkText
                variants={item}
                onClick={() => {
                  setNavigateDestination("/hello");
                  setShouldShow(false);
                }}
              >
                brief
              </DesktopLinkText>
              <DesktopLinkText
                variants={item}
                onClick={() => {
                  setNavigateDestination("https://news.sympler.co/sympler-insights");
                  setShouldShow(false);
                }}
              >
                insights
              </DesktopLinkText>
              <DesktopLinkText
                variants={item}
                onClick={() => {
                  setNavigateDestination("https://news.sympler.co/contact-us");
                  setShouldShow(false);
                }}
              >
                contact
              </DesktopLinkText>
            </DesktopMenuContainer>
          )}
        </AnimatePresence>

        <Menu
          size={20}
          toggled={shouldShow}
          toggle={setShouldShow}
          rounded
          label="Show menu"
          key={path}
        />
      </BurgerIconContainer>

      <AnimatePresence
        exitBeforeEnter
        onExitComplete={() => {
          if (navigateDestination !== "") {
            navigate(navigateDestination);
          }

          setNavigateDestination("");
        }}
      >
        {shouldShow && (
          <MobileMenuContainer
            key="bg"
            initial={{ opacity: 0, x: "50%" }}
            animate={{ opacity: 1, x: "0%" }}
            exit={{ opacity: 0, x: "50%" }}
            transition={{ duration: 0.3 }}
          >
            <MobileLinksContainer
              type="column"
              gap={1}
              style={{
                justifyContent: "flex-end"
              }}
            >
              <LinkText
                onClick={() => {
                  setNavigateDestination("/");
                  setShouldShow(false);
                }}
                style={{ fontWeight: path.endsWith("/") ? 600 : 200 }}
              >
                home
              </LinkText>

              <LinkText
                onClick={() => {
                  setNavigateDestination("/work");
                  setShouldShow(false);
                }}
                style={{ fontWeight: path.endsWith("/work") ? 600 : 200 }}
              >
                work
              </LinkText>
              <LinkText
                onClick={() => {
                  setNavigateDestination("/hello");
                  setShouldShow(false);
                }}
                style={{
                  fontWeight: path.endsWith("/hello") ? 600 : 200
                }}
              >
                brief
              </LinkText>
              <LinkText
                onClick={() => {
                  setNavigateDestination("https://news.sympler.co/sympler-insights");
                  setShouldShow(false);
                }}
                style={{
                  fontWeight: path.endsWith("https://news.sympler.co/sympler-insights") ? 600 : 200
                }}
              >
                insights
              </LinkText>
              <LinkText
                onClick={() => {
                  setNavigateDestination("https://news.sympler.co/contact-us");
                  setShouldShow(false);
                }}
                style={{
                  fontWeight: path.endsWith("https://news.sympler.co/contact-us") ? 600 : 200
                }}
              >
                contact
              </LinkText>              
            </MobileLinksContainer>
          </MobileMenuContainer>
        )}
      </AnimatePresence>
    </Nav>
  );
}

export default Navigation;

const Nav = styled(motion.nav)`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 4rem 10%;
  z-index: 1000;
  background: transparent;
`;

const BurgerIconContainer = styled(Stack)<{
  path: string;
  shouldShow: boolean;
}>`
  --dark: hsl(0 0% 30%);
  --light: white;

  // transform: translate(4px, 5px);
  position: relative;
  z-index: 1000;
  color: ${(p) =>
    p.path.startsWith("/work") && p.path.length > 6
      ? "var(--light)"
      : "var(--dark)"};

  @media (max-width: 950px) {
    color: ${(p) => (p.shouldShow ? "var(--light)" : "var(--dark)")};
  }
`;

const Menu = styled(Hamburger)``;

const DesktopMenuContainer = styled(Stack)`
  @media (max-width: 950px) {
    display: none;
  }
`;

const MobileMenuContainer = styled(motion.div)`
  display: none;

  @media (max-width: 950px) {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(99, 94, 192, 0.75);
    backdrop-filter: blur(6px);
    z-index: 4;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const MobileLinksContainer = styled(Stack)`
  display: none;

  @media (max-width: 950px) {
    display: grid;
    justify-content: center;
    grid-auto-rows: min-content;
    /* padding: 16rem 5rem; */
  }
`;

const DesktopLinkText = styled(motion.p)`
  font-size: 2.2rem;
  font-weight: 400;
  letter-spacing: 0.5px;
  font-family: "Catamaran", sans-serif;
  color: currentColor;
  cursor: pointer;
`;

const LinkText = styled.p`
  font-size: 3.5rem;
  text-align: right;
  font-weight: 400;
  letter-spacing: 0.5px;
  /* font-family: "Open Sans", sans-serif; */
  color: white;
`;

const BrandLogoContainer = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  transform: translateY(-2px);

  svg {
    height: 100%;
  }
`;

function BrandLogo() {
  return (
    <svg viewBox="0 0 352 83" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.48 44.595c-2.32-16.302-16.522-28.592-33.044-28.592-4.249 0-8.362.777-12.203 2.285-.427.167-.242.863.217.863 1.122 0 2.24.12 3.325.355 5.983 1.297 9.093 6.877 9.293 7.247l16.58 28.67c1.53 2.646 4.464 4.416 7.332 3.36 1.567-.577 3.226-1.506 4.588-3.003 4.302-4.729 3.936-10.86 3.912-11.185z"
        fill="url(#p0l)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.497 20.881a14.372 14.372 0 00-3.029-.32c-4.783 0-8.407 2.354-8.668 2.528C4.665 29.457 0 39.007 0 49.293c0 9.216 3.74 17.732 10.082 23.87.742.718 2.117-.488 1.8-1.471-1.877-5.836 1.442-11.328 1.648-11.66l16.608-28.62c1.55-2.669 1.605-6.131-.778-8.093-1.285-1.057-2.912-2.016-4.863-2.438z"
        fill="url(#p1l)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.57 56.817c-3.823 4.192-9.654 4.404-10.784 4.405-.093 0-.149-.002-.163-.002H19.472c-3.068 0-6.075 1.667-6.592 4.69-.28 1.637-.304 3.522.305 5.417 1.988 6.187 7.704 8.937 7.762 8.965l.064.03a33.337 33.337 0 0012.345 2.348c15.562 0 28.671-10.655 32.36-25.025.254-.994-1.455-1.585-2.146-.828z"
        fill="url(#p2l)"
      />
      <path
        d="M116.217 35.457l-2.929 3.027c-2.431-2.365-4.807-3.548-7.129-3.548-1.476 0-2.745.489-3.809 1.465-1.041.977-1.562 2.116-1.562 3.418 0 1.15.434 2.246 1.302 3.288.868 1.063 2.691 2.311 5.469 3.743 3.385 1.758 5.685 3.45 6.901 5.078 1.193 1.65 1.79 3.505 1.79 5.567 0 2.908-1.02 5.37-3.06 7.39-2.04 2.017-4.59 3.026-7.65 3.026-2.04 0-3.993-.444-5.86-1.334-1.844-.89-3.374-2.116-4.589-3.679l2.865-3.255c2.322 2.626 4.785 3.939 7.389 3.939 1.823 0 3.375-.586 4.655-1.758 1.28-1.172 1.92-2.55 1.92-4.134 0-1.302-.423-2.463-1.269-3.483-.846-.998-2.756-2.257-5.729-3.776-3.19-1.65-5.36-3.277-6.51-4.883-1.15-1.606-1.726-3.44-1.726-5.501 0-2.691.912-4.926 2.734-6.706 1.845-1.78 4.167-2.67 6.967-2.67 3.255 0 6.532 1.596 9.83 4.786zm5.964-3.874h4.818l12.174 27.279 11.817-27.279h4.85l-21.127 48.373h-4.817l6.836-15.625-14.551-32.748zm41.185 0h4.525v6.12c1.584-2.257 3.211-3.906 4.882-4.948 2.301-1.389 4.72-2.083 7.259-2.083 1.715 0 3.343.336 4.883 1.009 1.541.673 2.8 1.573 3.776 2.702.977 1.107 1.823 2.702 2.539 4.785 1.52-2.778 3.418-4.883 5.697-6.315 2.279-1.454 4.731-2.181 7.357-2.181 2.452 0 4.611.618 6.478 1.855 1.888 1.237 3.287 2.963 4.199 5.176.911 2.214 1.367 5.534 1.367 9.961V67h-4.655V47.664c0-3.798-.271-6.402-.814-7.812-.542-1.433-1.475-2.583-2.799-3.451-1.302-.868-2.865-1.302-4.688-1.302-2.213 0-4.242.651-6.087 1.953-1.823 1.302-3.157 3.038-4.004 5.208-.846 2.17-1.269 5.795-1.269 10.873V67h-4.525V48.868c0-4.275-.271-7.172-.814-8.69-.521-1.542-1.443-2.768-2.767-3.68-1.324-.932-2.897-1.4-4.72-1.4-2.105 0-4.08.641-5.924 1.922-1.823 1.258-3.18 2.962-4.069 5.11-.868 2.149-1.302 5.436-1.302 9.863V67h-4.525V31.583zm64.329 0h4.525v6.51c1.801-2.473 3.874-4.329 6.217-5.566 2.344-1.237 4.959-1.855 7.846-1.855 5.034 0 9.342 1.812 12.923 5.436 3.58 3.624 5.371 7.986 5.371 13.086 0 5.208-1.78 9.635-5.339 13.281-3.537 3.624-7.812 5.437-12.825 5.437-2.821 0-5.415-.587-7.78-1.758-2.366-1.172-4.503-2.92-6.413-5.241v19.043h-4.525V31.583zm18.229 3.483c-3.949 0-7.28 1.378-9.993 4.134-2.691 2.757-4.037 6.185-4.037 10.287 0 2.69.597 5.11 1.791 7.26 1.215 2.148 2.94 3.851 5.176 5.11 2.257 1.258 4.633 1.888 7.129 1.888 2.452 0 4.752-.63 6.901-1.888 2.17-1.28 3.895-3.06 5.175-5.339 1.281-2.278 1.921-4.666 1.921-7.161 0-2.518-.64-4.905-1.921-7.162-1.258-2.257-2.962-4.004-5.11-5.24-2.149-1.26-4.492-1.889-7.032-1.889zm28.197-17.155h4.557V67h-4.557V17.911zm45.514 37.338l3.842 2.018c-1.259 2.474-2.713 4.47-4.362 5.99a17.566 17.566 0 01-5.567 3.483c-2.061.78-4.394 1.172-6.999 1.172-5.772 0-10.286-1.889-13.541-5.665-3.255-3.797-4.883-8.083-4.883-12.858 0-4.492 1.378-8.496 4.134-12.011 3.494-4.47 8.171-6.706 14.03-6.706 6.033 0 10.851 2.29 14.453 6.868 2.561 3.234 3.863 7.27 3.906 12.11h-31.836c.087 4.123 1.4 7.508 3.939 10.156 2.539 2.626 5.675 3.939 9.408 3.939 1.801 0 3.548-.315 5.241-.944 1.714-.63 3.168-1.465 4.362-2.507 1.193-1.041 2.485-2.723 3.873-5.045zm0-9.538c-.607-2.43-1.497-4.373-2.669-5.827-1.15-1.454-2.68-2.626-4.59-3.516a14.09 14.09 0 00-6.022-1.334c-3.472 0-6.456 1.117-8.952 3.353-1.823 1.627-3.201 4.069-4.134 7.324h26.367zm13.483-14.128h4.655v5.176c1.389-2.04 2.854-3.559 4.395-4.557 1.541-1.02 3.147-1.53 4.818-1.53 1.258 0 2.604.401 4.036 1.204l-2.376 3.841c-.955-.412-1.758-.618-2.409-.618-1.519 0-2.984.63-4.395 1.888-1.41 1.237-2.484 3.168-3.222 5.794-.564 2.019-.847 6.098-.847 12.24V67h-4.655V31.583z"
        fill="black"
      />
      <defs>
        <linearGradient
          id="p0l"
          x1={18.7819}
          y1={53.3271}
          x2={66.4976}
          y2={53.3271}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7ECEFD" />
          <stop offset={1} stopColor="#9EBDFF" />
        </linearGradient>
        <linearGradient
          id="p1l"
          x1={10.0713}
          y1={26.1918}
          x2={29.9611}
          y2={72.3083}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FC7D49" />
          <stop offset={1} stopColor="#FF788D" />
        </linearGradient>
        <linearGradient
          id="p2l"
          x1={58.3158}
          y1={56.073}
          x2={18.1172}
          y2={80.5921}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1A5F6" />
          <stop offset={1} stopColor="#FC89CB" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function BrandLogoWhite() {
  return (
    <svg
      width="171px"
      height="41px"
      viewBox="0 0 171 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.2598 21.64C31.1334 13.7293 24.2424 7.76563 16.2252 7.76563C14.1633 7.76563 12.1673 8.14274 10.3036 8.87431C10.0965 8.95561 10.1861 9.29346 10.4086 9.29346C10.9533 9.29346 11.4961 9.35143 12.0222 9.46541C14.9253 10.0947 16.4345 12.8026 16.5315 12.9819L24.5775 26.8945C25.3198 28.1781 26.7434 29.0371 28.135 28.5248C28.8952 28.245 29.7002 27.7939 30.3611 27.0675C32.449 24.7728 32.2712 21.7981 32.2598 21.64Z"
        fill="url(#paint0_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8872 10.1328C11.4084 10.0294 10.9139 9.97705 10.4174 9.97705C8.09629 9.97705 6.33788 11.1195 6.21147 11.204C2.26357 14.294 -3.5343e-08 18.928 -5.50517e-08 23.9195C-7.27095e-08 28.3915 1.81523 32.5239 4.8922 35.5025C5.25233 35.8511 5.91957 35.2657 5.76607 34.7886C4.85476 31.9567 6.46553 29.2919 6.56528 29.1308L14.6246 15.2431C15.3765 13.9476 15.4035 12.2675 14.2469 11.3158C13.6236 10.8029 12.834 10.3373 11.8872 10.1328Z"
        fill="url(#paint1_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.8473 27.5708C28.9923 29.6049 26.1628 29.7079 25.6144 29.7081C25.5693 29.7081 25.5423 29.7072 25.5354 29.7072L9.44866 29.7072C7.96026 29.7072 6.50086 30.516 6.24982 31.983C6.11393 32.7772 6.10229 33.692 6.3978 34.6117C7.36272 37.6138 10.1366 38.9485 10.1647 38.9617L10.1954 38.9762C12.1024 39.7325 14.1179 40.116 16.186 40.116C23.7375 40.116 30.0988 34.9455 31.8884 27.9722C32.0121 27.4903 31.1827 27.2032 30.8473 27.5708Z"
        fill="url(#paint2_linear)"
      />
      <path
        d="M56.3947 17.6937L54.9731 19.1627C53.7937 18.0149 52.6406 17.441 51.5138 17.441C50.7977 17.441 50.1816 17.6779 49.6656 18.1518C49.1602 18.6257 48.9074 19.1785 48.9074 19.8104C48.9074 20.3685 49.1181 20.9003 49.5393 21.4058C49.9605 21.9218 50.8451 22.5273 52.193 23.2223C53.8358 24.0753 54.952 24.8967 55.5417 25.6865C56.1209 26.4868 56.4105 27.3872 56.4105 28.3876C56.4105 29.7987 55.9156 30.9939 54.9257 31.9733C53.9358 32.9526 52.6985 33.4423 51.2137 33.4423C50.2238 33.4423 49.276 33.2264 48.3704 32.7947C47.4753 32.3629 46.7329 31.7679 46.1431 31.0097L47.5332 29.4301C48.66 30.7043 49.8552 31.3414 51.1189 31.3414C52.0035 31.3414 52.7564 31.0571 53.3777 30.4884C53.999 29.9198 54.3097 29.2511 54.3097 28.4824C54.3097 27.8505 54.1043 27.2871 53.6936 26.7922C53.2829 26.3078 52.3562 25.697 50.9135 24.9598C49.3655 24.1595 48.3125 23.3697 47.7543 22.5905C47.1962 21.8112 46.9171 20.9213 46.9171 19.9209C46.9171 18.6151 47.3594 17.5305 48.244 16.667C49.1391 15.8034 50.2659 15.3717 51.6243 15.3717C53.2039 15.3717 54.7941 16.1457 56.3947 17.6937ZM59.2886 15.814H61.6264L67.5341 29.051L73.268 15.814H75.6216L65.37 39.2868H63.0322L66.3494 31.7047L59.2886 15.814ZM79.2736 15.814H81.4693V18.7836C82.238 17.6884 83.0278 16.8881 83.8387 16.3826C84.9549 15.7087 86.1291 15.3717 87.3612 15.3717C88.1931 15.3717 88.9829 15.5349 89.7306 15.8614C90.4782 16.1878 91.089 16.6248 91.5629 17.1724C92.0368 17.7095 92.4475 18.4835 92.795 19.4944C93.5321 18.1465 94.4536 17.125 95.5593 16.43C96.665 15.7245 97.8549 15.3717 99.1292 15.3717C100.319 15.3717 101.367 15.6718 102.273 16.2721C103.189 16.8723 103.868 17.7095 104.31 18.7836C104.753 19.8577 104.974 21.4689 104.974 23.6172V33H102.715V23.6172C102.715 21.7743 102.583 20.5106 102.32 19.8262C102.057 19.1311 101.604 18.573 100.961 18.1518C100.33 17.7306 99.5714 17.5199 98.6869 17.5199C97.6127 17.5199 96.6281 17.8359 95.733 18.4677C94.8484 19.0995 94.2008 19.942 93.7901 20.9951C93.3794 22.0481 93.1741 23.8067 93.1741 26.2709V33H90.9784V24.2016C90.9784 22.1271 90.8468 20.7213 90.5835 19.9841C90.3308 19.2364 89.8832 18.6415 89.2409 18.1992C88.5985 17.7464 87.835 17.5199 86.9505 17.5199C85.929 17.5199 84.9707 17.8306 84.0756 18.4519C83.191 19.0627 82.5329 19.8893 82.1011 20.9319C81.6799 21.9744 81.4693 23.5698 81.4693 25.7181V33H79.2736V15.814ZM110.49 15.814H112.685V18.9732C113.559 17.7727 114.565 16.8723 115.702 16.2721C116.84 15.6718 118.109 15.3717 119.509 15.3717C121.952 15.3717 124.043 16.251 125.78 18.0096C127.518 19.7682 128.386 21.8849 128.386 24.3596C128.386 26.887 127.523 29.0352 125.796 30.8044C124.079 32.563 122.005 33.4423 119.572 33.4423C118.203 33.4423 116.945 33.158 115.797 32.5893C114.649 32.0206 113.612 31.1729 112.685 30.0462V39.2868H110.49V15.814ZM119.335 17.5041C117.419 17.5041 115.802 18.1728 114.486 19.5102C113.18 20.8476 112.527 22.5115 112.527 24.5018C112.527 25.8076 112.817 26.9817 113.396 28.0243C113.986 29.0668 114.823 29.8935 115.908 30.5042C117.003 31.115 118.156 31.4204 119.367 31.4204C120.557 31.4204 121.673 31.115 122.716 30.5042C123.769 29.8829 124.606 29.0194 125.227 27.9137C125.849 26.808 126.159 25.6496 126.159 24.4386C126.159 23.217 125.849 22.0587 125.227 20.9635C124.616 19.8683 123.79 19.0206 122.747 18.4203C121.705 17.8095 120.567 17.5041 119.335 17.5041ZM133.018 9.17967H135.229V33H133.018V9.17967ZM155.104 27.2977L156.968 28.277C156.357 29.4775 155.651 30.4463 154.851 31.1835C154.051 31.9206 153.15 32.484 152.15 32.8736C151.15 33.2527 150.017 33.4423 148.754 33.4423C145.953 33.4423 143.762 32.5261 142.183 30.6938C140.603 28.8509 139.813 26.7711 139.813 24.4544C139.813 22.2745 140.482 20.3316 141.819 18.6257C143.515 16.4563 145.784 15.3717 148.627 15.3717C151.555 15.3717 153.893 16.4827 155.641 18.7046C156.883 20.2737 157.515 22.2324 157.536 24.5807H142.088C142.13 26.5816 142.767 28.2244 143.999 29.5091C145.231 30.7833 146.753 31.4204 148.564 31.4204C149.438 31.4204 150.286 31.2677 151.107 30.9623C151.939 30.6569 152.645 30.2515 153.224 29.746C153.803 29.2406 154.43 28.4244 155.104 27.2977ZM155.104 22.6694C154.809 21.49 154.377 20.5475 153.809 19.842C153.25 19.1364 152.508 18.5677 151.581 18.136C150.655 17.7042 149.68 17.4884 148.659 17.4884C146.974 17.4884 145.526 18.0307 144.315 19.1153C143.431 19.9051 142.762 21.0898 142.309 22.6694H155.104ZM161.646 15.814H163.905V18.3255C164.579 17.3357 165.29 16.5985 166.038 16.1141C166.785 15.6192 167.565 15.3717 168.376 15.3717C168.986 15.3717 169.639 15.5665 170.334 15.9561L169.181 17.8201C168.718 17.62 168.328 17.5199 168.012 17.5199C167.275 17.5199 166.564 17.8253 165.88 18.4361C165.195 19.0364 164.674 19.9736 164.316 21.2478C164.042 22.2271 163.905 24.2069 163.905 27.1871V33H161.646V15.814Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="9.11402"
          y1="25.8773"
          x2="32.2682"
          y2="25.8773"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7ECEFD" />
          <stop offset="1" stopColor="#9EBDFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="4.8871"
          y1="12.7096"
          x2="14.5387"
          y2="35.0878"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FC7D49" />
          <stop offset="1" stopColor="#FF788D" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="28.2978"
          y1="27.2096"
          x2="8.79138"
          y2="39.1075"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1A5F6" />
          <stop offset="1" stopColor="#FC89CB" />
        </linearGradient>
      </defs>
    </svg>
  );
}
